/** Exactly one slash between them: base URLs end with a slash on some deployments, hrefs may start with one. */
export function joinUrl(base: string | undefined, path: string): string {
    if (!base) return path;
    return `${base.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}
